import React                            from 'react';
import { Observe }                      from 'rewire-core';
import {
  WithStyle,
  FormView
}                                       from 'rewire-ui';
import { Theme }                        from '@material-ui/core/styles';
import DraggableResizableDialog         from '../ui/DraggableResizableDialog';
import { withStyles }                   from '../utility/styles';
import ArchiveDeleteDialogModel         from './ArchiveDeleteDialogModel';

const styles = (_theme: Theme) => ({
});

interface IArchiveDeleteDialogProps {
  model: ArchiveDeleteDialogModel;
}

type ArchiveDeleteDialogProps = WithStyle<ReturnType<typeof styles>, IArchiveDeleteDialogProps>;

class ArchiveDeleteDialog extends React.PureComponent<ArchiveDeleteDialogProps> {
  constructor(props: ArchiveDeleteDialogProps) {
    super(props);
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={this.props.model.form} onSubmit={this.props.model.actionFn('save')}>
        <div className='content'>
          <this.props.model.form.field.endDate.Editor className='span1' />
        </div>
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: this.props.model}} DraggableResizableBoxProps={{minWidth: '250px', minHeight: '242px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IArchiveDeleteDialogProps>(styles, ArchiveDeleteDialog);
